
import { Component, OnInit, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder, NG_VALUE_ACCESSOR } from '@angular/forms';

import { InitialisationService } from 'qmuzik-angular-service';
import { EISTaskSecurityService } from '../../../../shared/service/generated/eistasksecurity.service';
import { EISTaskSecurity } from 'qmuzik-angular-model';
import { EISTaskSecurityModelStateValidation } from '../../../../shared/modelstate-validation/generated/eistasksecurity-modelstate.validate';
import { EISTaskSecurityViewStateValidation } from '../../../../shared/viewstate-validation/generated/eistasksecurity-viewstate.validate';
import { ModelStateValidation } from 'qmuzik-angular-model-core';
import { ModelStateValidationBase } from 'qmuzik-angular-base';
import { ViewStateValidation } from 'qmuzik-angular-model-core';
import { ViewStateValidationBase } from 'qmuzik-angular-base';

import { EISTaskSecurityComponent } from '../../../../shared/base/entity-component/generated/eistasksecurity-component.base'
import { LoginService } from 'qmuzik-angular-service';
import { ComponentBase } from 'qmuzik-angular-base';
import { UtilityService } from 'qmuzik-angular-service';
import { NotificationService } from 'qmuzik-angular-service';
import { Route, Router } from '@angular/router';

@Component({
  selector: 'app-eistasksecurity-standard-search',
  templateUrl: './eistasksecurity-standard-search.component.html',
  styleUrls: ['./eistasksecurity-standard-search.component.css'],
  providers: [
    EISTaskSecurityModelStateValidation,
    EISTaskSecurityViewStateValidation,
    {
    provide: NG_VALUE_ACCESSOR,
    useExisting: EISTaskSecurityStandardSearchComponent,
    multi: true
  }]
})
//create the standard/default version of view
//this version will not implement any functionality not provided by the EISTaskSecurityComponent
//extend EISTaskSecurityComponent yourself for custom versions
export class EISTaskSecurityStandardSearchComponent extends EISTaskSecurityComponent implements OnInit {
	//you can give the view your own name if you want
	//your own security and viewstate metadat set up for it
	viewName = "EISTaskSecuritySearch";
	//override: create your own class that inherits from this to add properties to model
	//you don't need to specify if the standard is used
	//modelState = new extendedEISTaskSecurity() as EISTaskSecurity; 

	//there is now way around this in typescript
	//if you create a constructor for base class you must call super
	//with all injected instances (even if it is the same as base class)
	//e.g. if you haven't created your own extension, then you must supply
	//the standard one
	constructor(
		private extendedInitialisationService: InitialisationService,
		private extendedDataService: EISTaskSecurityService,
		private extendedModelStateValidation: EISTaskSecurityModelStateValidation,
		private extendedViewStateValidation: EISTaskSecurityViewStateValidation,
		loginService: LoginService,
		utilityService: UtilityService,
		notificationService: NotificationService,
		router: Router      
	) 
	{        
		super(
			extendedInitialisationService as InitialisationService, 
			extendedDataService as EISTaskSecurityService, 
			extendedModelStateValidation as EISTaskSecurityModelStateValidation, 
			extendedViewStateValidation as EISTaskSecurityViewStateValidation,
			loginService,
			utilityService,
			notificationService,
			router
		);
	}

	ngOnInit() {
		this.searchMode = true;
		super.ngOnInit();    
	}

	onSumbit(){}
}

